//   const updateParents = (rootItems, updated) => {
//     const traverseUp = (items) => {
//       items.forEach((item) => {
//         if (item.children && item.children.length > 0) {
//           // First update all nested
//           traverseUp(item.children);

//           const allChecked = item.children.every(
//             (child) => updated[child.name]
//           );
//           const anyChecked = item.children.some((child) => updated[child.name]);
//           updated[item.name] = allChecked;

//           // optional: If you want partial selection (indeterminate) logic later, use `anyChecked`
//         }
//       });
//     };
//     traverseUp(rootItems);
//     return updated;
//   };

//   const handleCheckChange = (item, checked) => {
//     let updated = { ...checkedItems };
//     updated = { ...updated, ...updateChildren(item, checked) };
//     updated = updateParents(data, updated);

//     setCheckedItems(updated);
//   };

import React, { useEffect, useState } from "react";
import Button from "../Buttons/Button";
import CustomCheckboxNew from "../FormFields/Custom/CustomCheckboxNew";

const styles = {
  headerStyle:
    "px-4 py-4 text-left border-b-[1px] border-slate-200 text-xs text-nowrap text-md font-medium min-w-[100px]",
};

const PermissionRow = ({
  item,
  level = 0,
  onCheckChange,
  checkedItems,
  disabledItems,
  indeterminateItems,
}) => {  
  const [isOpen, setIsOpen] = useState(false);
  const hasChildren = item.children && item.children.length > 0;

  // const isChecked = checkedItems[item.name] || false;

  const isChecked = checkedItems[item.key] || false;
  const isDisabled = disabledItems[item.key] || false;

  // const isIndeterminate = !!indeterminateItems?.[item?.name];
  const isIndeterminate = !!indeterminateItems?.[item?.key];

  const toggleOpen = () => {
    if (hasChildren) setIsOpen(!isOpen);
  };

  const handleCheckboxChange = (value) => {
    onCheckChange(item, value);
  };

  return (
    <>
      <tr className="border-b border-slate-200 flex justify-between items-center">
        <td className="px-4 py-2">
          <div
            className={`flex items-center cursor-pointer`}
            style={{ paddingLeft: `${level * 25}px` }}
            onClick={toggleOpen}
          >
            <Button
              type="icon"
              icon={hasChildren ? (isOpen ? "folder_open" : "folder") : "news"}
              variant="text"
              color="black"
            />
            <span className={`${level === 0 && `text-info`}`}>{item.name}</span>
          </div>
        </td>
        <td className="px-4 pr-15 py-2 text-center">
          <CustomCheckboxNew
            // id={`select-all-checkbox-${item.name}`}
            id={`select-all-checkbox-${item.key}`}
            checked={isChecked}
            disabled={isDisabled}
            indeterminate={isIndeterminate}
            onChange={(e) => handleCheckboxChange(e.target.checked)}
          />
        </td>
      </tr>
      {isOpen &&
        hasChildren &&
        item.children.map((child) => (
          <PermissionRow
            // key={child.name}
            key={child.key}
            item={child}
            level={level + 1}
            onCheckChange={onCheckChange}
            checkedItems={checkedItems}
            disabledItems={disabledItems}
            indeterminateItems={indeterminateItems}
          />
        ))}
    </>
  );
};

const PermissionTable = ({ data, onSelectionChange,  preselectedModules = [], disabledItems = [] }) => {
  const [checkedItems, setCheckedItems] = useState({});
  const [indeterminateItems, setIndeterminateItems] = useState({});
  const [selectedKeys, setSelectedKeys] = useState({});
  const [disabledKeys, setDisabledKeys] = useState({});

  const updateChildren = (item, checked, updated = {}) => {
    // updated[item.name] = checked;
    updated[item.key] = checked;
    if (item.children && item.children.length > 0) {
      item.children.forEach((child) => updateChildren(child, checked, updated));
    }
    return updated;
  };

  const updateParents = (rootItems, updated, indeterminate = {}) => {
    const traverseUp = (items) => {
      items.forEach((item) => {
        if (item.children && item.children.length > 0) {
          traverseUp(item.children);

          const allChecked = item.children.every(
            // (child) => updated[child.name]
            (child) => updated[child.key]
          );
          const anyChecked = item.children.some(
            // (child) => updated[child.name] || indeterminate[child.name]
            (child) => updated[child.key] || indeterminate[child.key]
          );

          // ✅ parent checked only if all children are checked
          // updated[item.name] = allChecked;
          updated[item.key] = allChecked;

          // ✅ parent indeterminate if some (but not all) children are checked
          // indeterminate[item.name] = anyChecked && !allChecked;
          indeterminate[item.key] = anyChecked && !allChecked;
        } else {
          // leaf node => never indeterminate
          // indeterminate[item.name] = false;
          indeterminate[item.key] = false;
        }
      });
    };

    traverseUp(rootItems);
    return { updated, indeterminate };
  };

  const buildSelectedTree = (items, updated) => {
    return items
      .map((item) => {
        const isChecked = updated[item.key];
        const hasChildren = item.children && item.children.length > 0;
        const builtChildren = hasChildren
          ? buildSelectedTree(item.children, updated)
          : [];

        if (isChecked || builtChildren.length > 0) {
          return {
            type: item.type === "path" ? 1 : 2,
            key: item.key,
            path: item.path || "",
            children: builtChildren,
          };
        }
        return null;
      })
      .filter(Boolean);
  };

  const handleCheckChange = (item, checked) => {
    let updated = { ...checkedItems };
    let indeterminate = { ...indeterminateItems };

    // Update children recursively
    updated = { ...updated, ...updateChildren(item, checked) };

    // After child changes, update parents (both checked + indeterminate)
    const result = updateParents(data, updated, indeterminate);
    updated = result.updated;
    indeterminate = result.indeterminate;

    setCheckedItems(updated);
    setIndeterminateItems(indeterminate);

    const structured = buildSelectedTree(data, updated);
    onSelectionChange?.(structured);
  };

  const extractCheckedKeys = (items) => {
    let keys = {};
    items.forEach((item) => {
      keys[item.key] = true;
      if (item.children && item.children.length > 0) {
        Object.assign(keys, extractCheckedKeys(item.children));
      }
    });
    return keys;
  };

  useEffect(() => {
    if (preselectedModules && preselectedModules.length > 0) {
      const keys = extractCheckedKeys(preselectedModules);
      setSelectedKeys(keys);
    }
  }, [preselectedModules]);

  useEffect(() => {
    if (disabledItems && disabledItems.length > 0) {
      const keys = extractCheckedKeys(disabledItems);
      setDisabledKeys(keys);
    }
  }, [disabledItems]);

  useEffect(() => {
    if (Object.keys(selectedKeys).length > 0) {
      setCheckedItems(selectedKeys);

      const { indeterminate } = updateParents(data, { ...selectedKeys }, {});
      setIndeterminateItems(indeterminate);
    }
  }, [selectedKeys]);

  return (
    <table className="w-full">
      <thead className="bg-primary-50 sticky top-0 select-none z-[51] flex justify-between">
        <th
          className={`${styles.headerStyle} truncate overflow-hidden whitespace-nowrap`}
        >
          Feature
        </th>
        <th
          className={`${styles.headerStyle} truncate overflow-hidden whitespace-nowrap`}
        >
          Add
        </th>
      </thead>
      <tbody>
        {data.map((item) => (
          <PermissionRow
            key={item.key}
            item={item}
            onCheckChange={handleCheckChange}
            checkedItems={checkedItems}
            disabledItems={disabledKeys}
            indeterminateItems={indeterminateItems}
          />
        ))}
      </tbody>
    </table>
  );
};

export default PermissionTable;
